import React from 'react';
import { Alert, Box, Button } from '@mui/material';
import { AIAgentNotice } from '../AIAgentTypes';

interface Props {
  notice?: AIAgentNotice;
  onRetry?: () => void;
  onStartNewConversation?: () => void;
}

export default function AIAgentStatusMessage({
  notice,
  onRetry,
  onStartNewConversation,
}: Props) {
  if (!notice) {
    return null;
  }

  return (
    <Box sx={{ px: 2, py: 1 }}>
      <Alert severity="warning" role="status">
        {notice.message}
        {notice.action === 'retry' && onRetry && (
          <Box sx={{ mt: 1 }}>
            <Button size="small" onClick={onRetry}>
              Tentar novamente
            </Button>
          </Box>
        )}
        {notice.action === 'start-new-conversation' && onStartNewConversation && (
          <Box sx={{ mt: 1 }}>
            <Button size="small" onClick={onStartNewConversation}>
              Iniciar nova conversa
            </Button>
          </Box>
        )}
      </Alert>
    </Box>
  );
}
